import '@styles/components/appBannerNew.less';
//import history from '@tools/history';
import { setTryOutDialog } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';

const AppBannerNew = () => {
  const dispatch = useAppDispatch();

  return (
    <div className={'app-banner'}>
      <img className={'banner-bg'} src={require('@images/common/bannerBg.png').default} alt="" />
      <div className={'content'}>
        <div className={'logo'}>
          <img src={require('@images/support/BIMWindows.png').default} alt="" />
        </div>
        <div className={'title'}>
          <span>看模王</span>
        </div>
        <div className={'desc'}>看模王荣耀为您</div>
        <div className={'theme'}>
          <img src={require('@images/common/BIMWindows.png').default} alt="" />
          <span>看模王</span>
          <p>BIM Windows</p>
        </div>
        <div className={'operate'}>
          <span className={'free-bim'} onClick={() => dispatch(setTryOutDialog(true))}>
            申请试用
          </span>
          {/* <span className={'buy'} onClick={() => history.push('/buy')}>
            立即购买
          </span> */}
        </div>
      </div>
    </div>
  );
};

export default AppBannerNew;
